import { render } from "./ImageAdditionalStatus.vue?vue&type=template&id=1f661496&scoped=true"
import script from "./ImageAdditionalStatus.vue?vue&type=script&lang=js"
export * from "./ImageAdditionalStatus.vue?vue&type=script&lang=js"

import "./ImageAdditionalStatus.vue?vue&type=style&index=0&id=1f661496&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f661496"]])

export default __exports__